// sorry (=
export const getPageNumbersTemplate = (currentPage: number, totalPages: number) => {
  if (totalPages < 8) {
    return Array(totalPages)
      .fill('')
      .map((_, i) => i + 1);
  } else if (currentPage === 4) {
    return [1, 2, 3, 4, 5, '...', totalPages];
  } else if (currentPage < 4) {
    return [1, 2, 3, 4, '...', totalPages];
  } else {
    if (currentPage === 5 && currentPage < totalPages - 3) {
      return [1, '...', currentPage - 1, currentPage, currentPage + 1, currentPage + 2, '...', totalPages];
    } else if (currentPage > 5 && currentPage < totalPages - 4) {
      return [1, '...', currentPage - 2, currentPage - 1, currentPage, currentPage + 1, currentPage + 2, '...', totalPages];
    } else if (currentPage === totalPages - 4) {
      return [1, '...', currentPage - 2, currentPage - 1, currentPage, currentPage + 1, '...', totalPages];
    } else if (currentPage === totalPages - 3) {
      return [1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    } else {
      return [1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    }
  }
};